import React from 'react';
import ModalManager from "./ModalManager";
import Panel from "./Panel";
import PlaceholderContent from "./PlaceholderContent";
import Spacer from "./Spacer";
import Input from "../../classes/Input";
import { assert } from "../../classes/utilities/ErrorHandling";
import { Spinner } from '../Iconset';
import { ModalProgressDialog } from '../dialog/ModalProgressDialog';

let standbyModalID = "";
let standbyModeBlockCount = 0;

export default class StandbyOverlay
{
	/**
	 * standby mode blocks user input from the application while it's doing something that shouldn't be interrupted by potential modifications
	 *
	 * use only when absolutely necessary, as it's generally bad UX to block user input
	 * @static
	 * @param {String | JSX.Element} message can be a plain string or an entire React Component; will be displayed under the spinner while standby mode is active
	 * @memberof Utils
	 */
	static startStandbyMode(message?: string | JSX.Element, showSpinner = true, secondaryMessage: string | JSX.Element = "Please wait...", staticWidth = false)
	{
		assert(standbyModeBlockCount >= 0);
		Input.clearAll();
		if (!standbyModalID)
		{
			standbyModalID = ModalManager.addModal({
				allowClickOut: false,
				content:
					<Panel className={"waitMessageRoot"}>
						<PlaceholderContent staticWidth={staticWidth}>
							{
								!message ? null :
									<>
										<div className={"largeText"}>
											{message}
										</div>
										<Spacer size={{ y: "12px" }} />
									</>
							}
							{
								!showSpinner ? null :
									<Spinner />
							}
							<Spacer size={{ y: "12px" }} />
							<div className={"largeText"}>
								{secondaryMessage}
							</div>
						</PlaceholderContent>
					</Panel>
			});
			Input.block();
		}
		standbyModeBlockCount++;
	}
	
	/**
	 * standby mode blocks user input from the application while it's doing something that shouldn't be interrupted by potential modifications
	 *
	 * use only when absolutely necessary, as it's generally bad UX to block user input
	 * @static
	 * @param {String | React.Component} message can be a plain string or an entire React Component; will be displayed under the spinner while standby mode is active
	 * @memberof Utils
	 */
	static updateStandbyModeMessage(message, staticWidth = false, secondMessage: string | React.ReactElement | null | undefined = null)
	{
		if (!standbyModalID) return;
		ModalManager.removeModal(standbyModalID);
		standbyModalID = ModalManager.addModal({
			allowClickOut: false,
			content: <ModalProgressDialog message={message} secondMessage={secondMessage} staticWidth={staticWidth} />
		});
	}
	
	/**
	 * removes the blockade imposed by Utils.startStandbyMode, allowing normal user input and interation with the application
	 * @static
	 * @memberof Utils
	 */
	static stopStandbyMode()
	{
		standbyModeBlockCount--;
		assert(standbyModeBlockCount >= 0);
		if (standbyModeBlockCount === 0)
		{
			ModalManager.removeModal(standbyModalID);
			standbyModalID = "";
			Input.release();
		}
	}
}